import { MsalModel } from "./msal.model";

const MS_STORAGE_KEY = "ms";

// Do not rename to "msal" — MS logout clears sessionStorage keys prefixed that way.

export function getStoredMsAccount(): MsalModel | null {
  const raw = localStorage.getItem(MS_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  return JSON.parse(raw) as MsalModel;
}

export function setStoredMsAccount(msal: MsalModel): void {
  localStorage.setItem(MS_STORAGE_KEY, JSON.stringify(msal));
}

export function getStoredAccountIdentifiers():
  | { localAccountId: string; homeAccountId: string; username: string }
  | undefined {
  const msal = getStoredMsAccount();
  if (!msal) {
    return undefined;
  }

  return {
    localAccountId: msal.localAccountId,
    homeAccountId: msal.homeAccountId,
    username: msal.username,
  };
}

export function hasStoredMsSession(): boolean {
  return localStorage.getItem(MS_STORAGE_KEY) !== null;
}

export function clearStoredMsAccount(): void {
  localStorage.removeItem(MS_STORAGE_KEY);
}
